import React from 'react';
import { useSelector } from 'react-redux';
import CIcon from '@coreui/icons-react';
import { useHistory } from 'react-router-dom';
import { selectChatData } from '../../selectors/chat.selector';

interface ChatHeaderProps {
  activeChatId: string;
}

const ChatHeader = (props: ChatHeaderProps) => {
  const {
    activeChatId
  } = props;

  const history = useHistory();

  const customer = useSelector(selectChatData)(activeChatId)?.chatInfo?.customer;

  const goBack = () => {
    history.push('/chat');
  };

  return (
    <div className="chat-view-header">
      <div className="back-button position-absolute ml-3">
        <CIcon size="xl" name="cil-arrow-left" onClick={goBack} />
      </div>
      <div className="chat-customer-name">
        {customer}
      </div>
    </div>
  );
};

export default ChatHeader;
